var PageUI = (function ($) {

    PageUI = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        that.$sidebar = that.$wrapper.find('.js-sidebar');
        that.$sidebar_toggler = that.$sidebar.find('.js-sidebar-mobile-toggler');
        that.$sidebar_toggle_box = that.$sidebar.find('.js-sidebar-toggle-box');
        that.$sidebar_list_wrapper = that.$sidebar.find('.js-sidebar-list-wrapper');

        that.$content = that.$wrapper.find('.js-content');

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    PageUI.prototype.init = function () {
        var that = this;

        //
        that.initSidebar();
        //
        that.initSidebarList();
        //
        that.initCalendar()
        //
        that.initIconCodeCopyByClick();
        //
        that.initHashChangerOnScroll();
        //
        that.initDrawerExamples();
        //
        that.initDrawerBottomExamples();
        //
        that.initModalExamples();
        //
        that.initNotifyExamples();
        //
        that.initScrollbarExamples();
        //
        that.initCounterExamples();
        //
        that.initPassengerCategoriesPickerExamples();
        //
        that.initTimelimitExamples();
    };

    PageUI.prototype.initSidebar = function () {
        var that = this,
            class_active = 'mobile-close';

        that.$sidebar_toggler.on('click', function () {
            that.$sidebar.toggleClass(class_active);
        });
    };

    PageUI.prototype.initSidebarList = function () {
        var that = this,
            $items = that.$content.find('.js-component-name[id]');

        $items.sort(function (a, b) {
            return a.innerHTML === b.innerHTML
                ? 0
                : (a.innerHTML > b.innerHTML ? 1 : -1);
        });

        $.each($items, function (i, item) {
            var item_params = {
                    'href': '#' + item.id,
                    'title': item.textContent,
                    'class': 'button small ghost full js-disable-router',
                    'style': 'justify-content: flex-start; text-align: left;'
                },
                $item = $('<a/>', item_params).text(item.textContent),
                item2_params = {
                    'href': '?only=' + item.id,
                    'class': 'button small ghost'
                },
                $item2 = $('<a/>', item2_params).html('<i class="fab fa-sa-fill-snowboard"></i>'),
                div_params = {
                    'class': 'flex space-4 margin-top'
                },
                $div = $('<div/>', div_params).append($item, $item2);
            
            that.$sidebar_list_wrapper.append($div);
        });
    };
    
    PageUI.prototype.initCalendar = function () {
        var that = this,
            $calendar_target_wrapper = that.$wrapper.find('.js-calendar-target-wrapper');
        
        $.uiCalendar({
            $wrapper: $calendar_target_wrapper,
            month_first: $.sa.server_datetime,
            month_count: 4,
        });
    };

    PageUI.prototype.initIconCodeCopyByClick = function () {
        var that = this,
            $icons_list = that.$wrapper.find('.js-icons-list');

        $icons_list.on('click', 'svg[data-icon]', function () {
            var icon = $(this),
                icon_prefix = icon.data('prefix'),
                icon_name = icon.data('icon'),
                icon_code = '<i class="icon ' + icon_prefix + ' fa-' + icon_name + '"></i>',
                icon_filled = icon.parent('.icon-filled'),
                icon_badge = '';

            if (icon_filled.length) {
                var icon_filled_class = icon_filled.attr('class');

                if (icon.siblings('.icon-badge').length) {
                    icon_badge = icon.next('.icon-badge')[0].outerHTML;
                }
                icon_code = '<span class="' + icon_filled_class + '"><i class="icon ' + icon_prefix + ' fa-' + icon_name + '"></i>' + icon_badge + '</span>';
            }

            $.sa.notifier.show({
                notifier_class: $.sa.notifier.class.success,
                title: 'Иконка скопирована в буфер обмена',
                content: '<code>' + $.sa.escape(icon_prefix + ' fa-' + icon_name) + '</code>',
            });

            console.log('Icon copied to buffer:', icon_code);

            $.sa.copyToBuffer(icon_code);
        });
    }

    PageUI.prototype.initHashChangerOnScroll = function () {
        var that = this;

        if (!history.pushState) {
            return false;
        }

        $.sa.$document.bind('scroll', function () {
            that.$wrapper.find('.js-component-name[id]').each(function () {
                var $this = $(this),
                    top_offset = $this.offset().top,
                    height = $this.height(),
                    window_page_y_offset = $.sa.$window[0].pageYOffset + 10,
                    hash = $this.attr('id');

                if (
                    top_offset < window_page_y_offset &&
                    top_offset + height > window_page_y_offset
                ) {
                    $.sa.$window[0].history.pushState(null, null, '#' + hash);
                }
            });
        });
    }

    PageUI.prototype.initDrawerExamples = function () {
        var that = this,
            default_config = {
                header_title: 'Вернуть билет и снять места',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div class="padding-vertical">' +
                '<p>Пример компонента <code>$.uiDrawer();</code>.</p>' +
                '<p>Параметры:' +
                '<ul>' +
                    '<li><b>position</b>: left, right, top, button</li>' +
                    '<li><b>size</b>: extra-small, small, medium, large, full, 500px, 50%</li>' +
                    '<li><b>header_contrast</b>: true, false</li>' +
                    '<li><b>mobile_fullscreen</b>: true, false</li>' +
                '</ul>' +
                '<p>Коллбеки <code>onBgClick</code>, <code>onOpen</code>, <code>onClose</code> и <code>onResize</code>.</p>' +
                '</div>',
                button_confirm_text: 'Продолжить',
                button_cancel_text: 'Отменить',
                // Handlers
                onBgClick: function (modal, event) {
                    console.log('Drawer background clicked', modal, event);
                },
                onButtonConfirmClick: function (modal, event) {
                    console.log('Drawer button-confirm clicked', modal, event);
                },
                onButtonCancelClick: function (modal, event) {
                    console.log('Drawer button-clicked', modal, event);
                },
            };

        // Extra small
        that.$wrapper.on('click', '.js-drawer-example-extra-small-left', function () {
            var config = {position: 'left', size: 'extra-small'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-extra-small-right', function () {
            var config = {position: 'right', size: 'extra-small'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-extra-small-top', function () {
            var config = {position: 'top', size: 'extra-small'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-extra-small-bottom', function () {
            var config = {position: 'bottom', size: 'extra-small'};
            $.uiDrawer({...default_config, ...config});
        });

        // Small
        that.$wrapper.on('click', '.js-drawer-example-small-left', function () {
            var config = {position: 'left', size: 'small'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-small-right', function () {
            var config = {position: 'right', size: 'small'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-small-top', function () {
            var config = {position: 'top', size: 'small'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-small-bottom', function () {
            var config = {position: 'bottom', size: 'small'};
            $.uiDrawer({...default_config, ...config});
        });

        // Medium (default)
        that.$wrapper.on('click', '.js-drawer-example-left', function () {
            var config = {position: 'left'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-right', function () {
            var config = {position: 'right'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-top', function () {
            var config = {position: 'top'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-bottom', function () {
            var config = {position: 'bottom'};
            $.uiDrawer({...default_config, ...config});
        });

        // Large
        that.$wrapper.on('click', '.js-drawer-example-large-left', function () {
            var config = {position: 'left', size: 'large'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-large-right', function () {
            var config = {position: 'right', size: 'large'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-large-top', function () {
            var config = {position: 'top', size: 'large'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-large-bottom', function () {
            var config = {position: 'bottom', size: 'large'};
            $.uiDrawer({...default_config, ...config});
        });

        // Full
        that.$wrapper.on('click', '.js-drawer-example-full-left', function () {
            var config = {position: 'left', size: 'full'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-full-right', function () {
            var config = {position: 'right', size: 'full'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-full-top', function () {
            var config = {position: 'top', size: 'full'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-full-bottom', function () {
            var config = {position: 'bottom', size: 'full'};
            $.uiDrawer({...default_config, ...config});
        });

        // 500px
        that.$wrapper.on('click', '.js-drawer-example-500px-left', function () {
            var config = {position: 'left', size: '500px'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-500px-right', function () {
            var config = {position: 'right', size: '500px'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-500px-top', function () {
            var config = {position: 'top', size: '500px'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-500px-bottom', function () {
            var config = {position: 'bottom', size: '500px'};
            $.uiDrawer({...default_config, ...config});
        });

        // 50%
        that.$wrapper.on('click', '.js-drawer-example-50pr-left', function () {
            var config = {position: 'left', size: '50%'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-50pr-right', function () {
            var config = {position: 'right', size: '50%'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-50pr-top', function () {
            var config = {position: 'top', size: '50%'};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-50pr-bottom', function () {
            var config = {position: 'bottom', size: '50%'};
            $.uiDrawer({...default_config, ...config});
        });
        
        // Header contrast
        that.$wrapper.on('click', '.js-drawer-example-header-contrast-left', function () {
            var config = {position: 'left', header_contrast: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-header-contrast-right', function () {
            var config = {position: 'right', header_contrast: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-header-contrast-top', function () {
            var config = {position: 'top', header_contrast: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-header-contrast-bottom', function () {
            var config = {position: 'bottom', header_contrast: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-header-contrast-no-title-bottom', function () {
            var config = {...default_config, ...{position: 'bottom', header_contrast: true}};
            delete config.header_title;
            delete config.header_description;
            $.uiDrawer(config);
        });
        
        // Mobile fullscreen
        that.$wrapper.on('click', '.js-drawer-example-mobile-fullscreen-left', function () {
            var config = {position: 'left', mobile_fullscreen: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-mobile-fullscreen-right', function () {
            var config = {position: 'right', mobile_fullscreen: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-mobile-fullscreen-top', function () {
            var config = {position: 'top', mobile_fullscreen: true};
            $.uiDrawer({...default_config, ...config});
        });
        that.$wrapper.on('click', '.js-drawer-example-mobile-fullscreen-bottom', function () {
            var config = {position: 'bottom', mobile_fullscreen: true};
            $.uiDrawer({...default_config, ...config});
        });
    }

    PageUI.prototype.initDrawerBottomExamples = function () {
        var that = this;

        that.$wrapper.on('click', '.js-drawer-bottom-example', function () {
            $.uiDrawerBottom({
                header_contrast: true,
                header: 'Drawer Bottom',
                content: '<div class="padding-large">' +
                    '<p>Пример компонента <code>$.uiDrawerBottom();</code>.</p>' +
                    '<p>Параметры: <code>header_contrast</code>: <i>true|false</i>' +
                    '<p>Коллбеки <code>onBgClick</code>, <code>onOpen</code>, <code>onClose</code> и <code>onResize</code>.</p>' +
                    '<p>Если нужен scrollbar внутри — инициируйте его внутри <code>onOpen</code>, чтобы корректно рассчиталась высота.</p>' +
                    '</div>',
            });
        });
    }

    PageUI.prototype.initModalExamples = function () {
        var that = this,
            insurance_sample_string = '<p>Страхование от несчастного случая: до 400 000 ₽<br/>' +
                'Если ваш багаж повредят или потеряют: до 40 000 ₽<br/>' +
                'Если рейс задержат: до 10 000 ₽</p>',
            long_insurance_sample_string = insurance_sample_string;

        for (var i = 0; i < 20; i++) {
            long_insurance_sample_string += insurance_sample_string;
        }

        // Easy
        that.$wrapper.on('click', '.js-modal-example-1', function () {
            $.uiModal({
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
                // Handlers
                onBgClick: function (modal, event) {
                    console.log('Modal background clicked', modal, event);
                },
                onButtonConfirmClick: function (modal, event) {
                    console.log('Modal button-confirm clicked', modal, event);
                },
                onButtonCancelClick: function (modal, event) {
                    console.log('Modal button-clicked', modal, event);
                },
            });
        });

        // Easy with scrollbar
        that.$wrapper.on('click', '.js-modal-example-2', function () {
            $.uiModal({
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + long_insurance_sample_string + '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
                // Handlers
                onBgClick: function (modal, event) {
                    console.log('Modal background clicked', modal, event);
                },
                onButtonConfirmClick: function (modal, event) {
                    console.log('Modal button-confirm clicked', modal, event);
                },
                onButtonCancelClick: function (modal, event) {
                    console.log('Modal button-clicked', modal, event);
                },
            });
        });

        // With icons
        that.$wrapper.on('click', '.js-modal-example-3', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
            });
        });

        // With icons, without title
        that.$wrapper.on('click', '.js-modal-example-4', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                content: '<div>' +
                    '<p>Без заголовка иконки рисуются по центру модалки.</p>' +
                    insurance_sample_string +
                    '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
            });
        });

        // With icons and title
        that.$wrapper.on('click', '.js-modal-example-5', function () {
            $.uiModal({
                content: '<div>' + insurance_sample_string + '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
            });
        });

        // With image
        that.$wrapper.on('click', '.js-modal-example-6', function () {
            $.uiModal({
                header_image: '/wa-apps/avia/themes/smartavia/images/ui-demo/modal-header-image.png',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
            });
        });

        // With mobile fullscreen
        that.$wrapper.on('click', '.js-modal-example-7', function () {
            $.uiModal({
                mobile_fullscreen: true,
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' +
                    '<p><i class="fab fa-sa-fill-smartphone"></i> На мобилах модалка будет на на весь экран.</p>' +
                    insurance_sample_string +
                    '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
            });
        });

        // With mobile fullscreen with scrollbar
        that.$wrapper.on('click', '.js-modal-example-8', function () {
            $.uiModal({
                mobile_fullscreen: true,
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' +
                    '<p><i class="fab fa-sa-fill-smartphone"></i> На мобилах модалка будет на на весь экран.</p>' +
                    long_insurance_sample_string +
                    '</div>',
                button_confirm_text: 'Добавить за 349 ₽',
                button_cancel_text: 'Не нужна страховка',
            });
        });

        // button left
        that.$wrapper.on('click', '.js-modal-example-9', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                button_align_left: true,
                button_confirm_text: 'Confirm',
                button_cancel_text: 'Cancel',
            });
        });

        // button center
        that.$wrapper.on('click', '.js-modal-example-10', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                button_align_center: true,
                button_confirm_text: 'Confirm',
                button_cancel_text: 'Cancel',
            });
        });

        // button right
        that.$wrapper.on('click', '.js-modal-example-11', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                button_confirm_text: 'Confirm',
                button_cancel_text: 'Cancel',
            });
        });

        // button left
        that.$wrapper.on('click', '.js-modal-example-12', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                buttons_view_type: {
                    direction: 'vertical',
                    align: 'left'
                },
                button_confirm_text: 'Confirm',
                button_cancel: {
                    html: '<button class="link secondary none js-button-cancel">Cancel</button>'
                },
            });
        });

        // button center
        that.$wrapper.on('click', '.js-modal-example-13', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                buttons_view_type: {
                    direction: 'vertical',
                    align: 'center'
                },
                button_cancel: {
                    html: '<button class="link secondary none js-button-cancel">Cancel</button>'
                },
                button_confirm_text: 'Confirm',
            });
        });

        // button right
        that.$wrapper.on('click', '.js-modal-example-14', function () {
            $.uiModal({
                header_icons: '<i class="fab fa-sa-fill-ufo"></i><i class="fab fa-sa-fill-mood-suprised2"></i>',
                header_title: 'Вы не заказали страховку',
                header_description: 'Наверняка всё будет хорошо, но лучше перестраховаться.',
                content: '<div>' + insurance_sample_string + '</div>',
                buttons_view_type: {
                    direction: 'vertical',
                    align: 'right'
                },
                button_cancel: {
                    html: '<button class="link secondary none js-button-cancel">Cancel</button>'
                },
                button_confirm: {
                    text: 'Confirm',
                    button_class: 'my-custom-class'
                }
            });
        });
    }

    PageUI.prototype.initNotifyExamples = function () {
        var that = this;

        that.$wrapper.on('click', '.js-notify-example-warning', function () {
            $.sa.notifier.show({
                title: 'Cпасибо, что зашли, %username%.',
                content: 'Дефолные настройки используются как warning (предупреждение).',
            });
        });

        that.$wrapper.on('click', '.js-notify-example-success-one-button', function () {
            $.sa.notifier.show({
                notifier_class: $.sa.notifier.class.success,
                title: 'Success уведомление с кнопкой',
                content: 'Ниже есть кнопка, клик по которой вызовет <code>alert();</code> и закроет это уведомление.',
                button_confirm_text: 'Кнопка',
                button_confirm_onclick: function () {
                    alert('Вы кликнули по кнопке! Поздравляем!');
                }
            });
        });

        that.$wrapper.on('click', '.js-notify-example-plain-two-buttons', function () {
            $.sa.notifier.show({
                notifier_class: $.sa.notifier.class.plain,
                title: 'Plain уведомление с двумя кнопками',
                content: 'Ниже вы видите две кнопки. Больше их быть не может.<br><br>Они имеют предопределённые стили, которые <b>запрещается</b> редактировать, чтобы выдерживать общий дизайн.',
                button_confirm_text: 'Понятно',
                button_cancel_text: 'Очень красиво',
            });
        });

        that.$wrapper.on('click', '.js-notify-example-error-two-buttons-without-close', function () {
            $.sa.notifier.show({
                notifier_class: $.sa.notifier.class.error,
                title: 'Ошибка с двумя кнопками и без крестика',
                content: 'Если вам нужно отправить уведомление, которое нельзя закрывать крестиком, а только нажав на одну из кнопок, то в таком случаем передайте параметр <code class="nowrap">render_close_icon: false</code>.<br><br> Уведомления без крестика не закрываются автоматически, если не передан параметр <code>time</code>.<br><br>Логика автоматического "незакрытия" работет только с теми уведомлениями, где есть кнопка.',
                button_confirm_text: 'Понятно',
                button_cancel_text: 'Очень удобно',
                render_close_icon: false,
            });
        });

        that.$wrapper.on('click', '.js-notify-example-accent-custom-time', function () {
            $.sa.notifier.show({
                notifier_class: $.sa.notifier.class.accent,
                icon_class: 'fas fa-poo',
                title: 'Уведомление закроется через минуту',
                content: 'Разработчику даётся возможность управлять временем показа нотифая.<br><br>По умолчанию оно автоматически закрывается через 10 секунд (если не передан параметр <code class="nowrap">render_close_icon: false</code>).<br><br>А ещё здесь кастомная иконка уведомления. Передаётся в параметре <code>icon_class</code>.',
                time: 60000
            });
        });
    }

    PageUI.prototype.initScrollbarExamples = function () {
        var that = this,
            $example_1 = that.$wrapper.find('.js-scroll-example-1'),
            $example_2 = that.$wrapper.find('.js-scroll-example-2');

        setTimeout(function () {
            $.uiScrollbar($example_1);
            $.uiScrollbar($example_2);
        }, 300);
    }

    PageUI.prototype.initCounterExamples = function () {
        var that = this,
            $counter_example = that.$wrapper.find('.js-counter-example');

        that.$wrapper.on('change', '.js-counter-example-min-value-input', function () {
            var $input = $(this);
            try {
                UICounter.prototype.setMin($counter_example, this.value);
            } catch (e) {
                var message;
                if (e instanceof CounterMinGreaterThanMaxError) {
                    message = 'Минимальное значение не может быть больше максимального';
                } else if (e instanceof CounterInvalidValueError) {
                    message = 'Некорректное значение';
                } else {
                    message = 'Ошибка присвоения минимального значения';
                }
                UIInput.prototype.setError($input, message);
            }
        });

        that.$wrapper.on('change', '.js-counter-example-max-value-input', function () {
            var $input = $(this);
            try {
                UICounter.prototype.setMax($counter_example, this.value);
            } catch (e) {
                var message;
                if (e instanceof CounterMaxLessThanMinError) {
                    message = 'Максимальное значение не может быть больше минимального';
                } else if (e instanceof CounterInvalidValueError) {
                    message = 'Некорректное значение';
                } else {
                    message = 'Ошибка присвоения максимального значения';
                }
                UIInput.prototype.setError($input, message);
            }
        });

        that.$wrapper.on('change', '.js-counter-example-value-input', function () {
            var $input = $(this);
            try {
                UICounter.prototype.set($counter_example, this.value);
            } catch (e) {
                var message;
                if (e instanceof CounterValueIsOutOfRangeError) {
                    message = 'Это значение выходит за границы диапазона';
                } else if (e instanceof CounterInvalidValueError) {
                    message = 'Некорректное значение';
                } else {
                    message = 'Ошибка присвоения значения';
                }
                UIInput.prototype.setError($input, message);
            }
        });
    }

    PageUI.prototype.initPassengerCategoriesPickerExamples = function () {
        var that = this;

        new UIPassengerCategoriesPicker({
            $wrapper: that.$wrapper.find('.js-passenger-categories-picker-example-1'),
            category: {
                SRC: 1,
                YTH: 0,
                CNN: 0,
                INS: 0,
                INF: 0
            }, 
            subsidy: {
                has: true,
                value: true
            }
        });

        new UIPassengerCategoriesPicker({
            $wrapper: that.$wrapper.find('.js-passenger-categories-picker-example-2'),
            category: {
                ADT: 1,
                CNN: 0,
                INS: 0,
                INF: 0
            }, 
            subsidy: {
                has: false
            }
        });
    }

    PageUI.prototype.initTimelimitExamples = function () {
        var that = this,
            limit_time = 2 * 86400; // 2 days

        new UITimelimit({
            $wrapper: that.$wrapper.find('.js-timelimit-wrapper-example'),
            timelimit: limit_time
        });

        new UITimelimit({
            $wrapper: that.$wrapper.find('.js-timelimit-wrapper-example-no-units'),
            timelimit: limit_time,
            no_units: true
        });

        new UITimelimit({
            $wrapper: that.$wrapper.find('.js-timelimit-wrapper-example-custom-html'),
            timelimit: limit_time,
            custom_html: true
        });
    }

    return PageUI;
})($);
